import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/@cultureamp/frontend-svg-util/browser-sprite.js";
var symbol = new SpriteSymbol({
  "id": "ca-icon-maximize.icon",
  "use": "ca-icon-maximize.icon-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"ca-icon-maximize.icon\"><path d=\"M2 18V10.9825H3.96491V14.6787L14.6787 3.96491H10.9825V2H18V9.01754H16.0351V5.32126L5.32126 16.0351H9.01754V18H2Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol